"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL001_List = void 0;
const react_1 = __importDefault(require("react"));
const RegistButton_1 = require("../RegistButton");
const DSTL001_List_Child_1 = require("./component/DSTL001_List_Child");
exports.DSTL001_List = react_1.default.memo(({ isTeacher, isTest, isSurvey = false, isBackOffice, }) => {
    const handlerButtonClick = () => {
        if (isBackOffice) {
            APP.eventManager.publish('CHANGE_MENU', {
                showDepth: 'regist',
                props: {},
            });
        }
        else {
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'regist',
                id: undefined,
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isTeacher && !isBackOffice ? (react_1.default.createElement(DSTL001_List_Child_1.AssignmentTableStudents, { isTest: isTest, isSurvey: isSurvey })) : (react_1.default.createElement(DSTL001_List_Child_1.AssignmentTable, { isTeacher: isTeacher, isTest: isTest, isSurvey: isSurvey, isBackOffice: isBackOffice })),
        isTeacher && react_1.default.createElement(RegistButton_1.RegistButton, { handlerButtonClick: handlerButtonClick })));
});
